import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { inject } from '@angular/core'
import { AuthService } from '../services/auth/auth.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private router = inject(Router)
  private authService = inject(AuthService)

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isAuthenticated = sessionStorage.getItem('authToken')

    if (!isAuthenticated) {
      // Guarda a URL pretendida (ex.: link de e-mail pro Portal do Fornecedor) pra o
      // login redirecionar direto pra lá em vez de cair no destino padrão do perfil.
      this.authService.saveRedirectUrl(state.url)
      this.router.navigate(['login'])
      return false
    }

    return true
  }
}

export class authGuard {}
